import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const duration = 0.3;

const Transition = styled.div<Pick<FadeOutProps, 'shrink'>>`
  ${({ shrink }) => {
    if (shrink) {
      return `
        opacity: 1;
        max-height: 100vh;
        overflow: hidden;
        transition: opacity ${duration}s ease-out, max-height ${duration}s ease-out;

        &.out {
          opacity: 0;
          max-height: 0;
        }
      `;
    } else {
      return `
        opacity: 1;
        transition: opacity ${duration}s ease-out;

        &.out {
          opacity: 0;
        }
      `;
    }
  }}
`;

export interface FadeOutProps {
  /** When true, children will fade out and shrink. */
  out: boolean;
  /** When true, the children will shrink after fading out. */
  shrink?: boolean;
}

export const FadeOut = ({ out, shrink, children }: PropsWithChildren<FadeOutProps>) => {
  return (
    <Transition className={out ? 'out' : ''} shrink={shrink}>
      {children}
    </Transition>
  );
};

FadeOut.defaultProps = {
  shrink: true,
};
